var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgX = function SvgX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.005 17.682 34.172 5.1h-2.667l-9.667 10.927L14.172 5.1h-9l11.666 16.556L5.172 34.9h2.666L18.005 23.31 26.172 34.9h9L23.005 17.682Zm-3.667 4.14-1.166-1.656-9.334-13.08h4l7.667 10.596 1.167 1.656 9.833 13.74h-4l-8.167-11.257Z",
    fill: "#fff"
  })));
};
export default SvgX;